import { capitalizeFirstLetter } from '@utils/formatting-utils';

export function entityToBusinessUserDetails(data: any): any {
  const businessUserDetailsInfo =
    data?.SalesforceManagement?.entities?.businessUser?.views
      ?.SalesforceManagement_all?.properties;
  const personDetailsInfo =
    businessUserDetailsInfo.PersonID?.views?.SalesforceManagement_all
      ?.properties;
  const businessUserRetaledUsersInfo =
    data?.SalesforceManagement?.entities?.businessUser?.queries
      ?.salesforceManagement?.relatedUsers[0];

  return {
    name: personDetailsInfo?.FullName,
    businessUserCode: businessUserDetailsInfo?.Code,
    personCode: personDetailsInfo?.PersonCode,
    personId: businessUserDetailsInfo?.PersonID?.id,
    dateOfBirth: personDetailsInfo?.DateOfBirth,
    email: personDetailsInfo?.Email,
    phoneNumber: personDetailsInfo?.PhoneDetails?.PhoneNumber,
    phoneType: capitalizeFirstLetter(
      personDetailsInfo?.PhoneDetails?.PhoneType
    ),
    taxable: personDetailsInfo?.IsTaxable ? 'Yes' : 'No',
    isAdmin: businessUserDetailsInfo?.IsAdmin ? 'Yes' : 'No',

    createdBy: `${businessUserRetaledUsersInfo?.createdBy_firstName} ${businessUserRetaledUsersInfo?.createdBy_lastName}`,
    createdOn: businessUserDetailsInfo?.createdOn,
    modifiedBy: `${businessUserRetaledUsersInfo?.modifiedBy_firstName} ${businessUserRetaledUsersInfo?.modifiedBy_lastName}`,
    modifiedOn: businessUserDetailsInfo?.modifiedOn,

    type: businessUserDetailsInfo.Type?.Id,
    typeTitle: businessUserDetailsInfo.Type?.Title,
    account: businessUserDetailsInfo.Account,
    access: businessUserDetailsInfo.Access?.Id,
    accessTitle: businessUserDetailsInfo.Access?.Title,
    editableLineCharges: businessUserDetailsInfo.EditableLineChargesIDs?.map(
      (item: any) => item?.views?.PlanConfigManagement_all?.properties?.Id
    ),
    editableLineChargesTitle:
      businessUserDetailsInfo.EditableLineChargesIDs?.map(
        (item: any) => item?.views?.PlanConfigManagement_all?.properties?.Name
      ).join(', '),
    allowPolicyEndDateEdits: businessUserDetailsInfo.AllowPolicyEndDateEdits,
    allowPlanCoverEdits: businessUserDetailsInfo.AllowPlanCoverEdits,
    allowClauseEdits: businessUserDetailsInfo.AllowClauseEdits,
    allowGroupPolicy: businessUserDetailsInfo.AllowGroupPolicy,
    allowEndorsement: businessUserDetailsInfo.AllowEndorsement,
    allowEndorsementCostEdits:
      businessUserDetailsInfo.AllowEndorsementCostEdits,
    allowPolicyCorrection: businessUserDetailsInfo.AllowPolicyCorrection,
    SalesforceManagement_BusinessUserStatuses: businessUserDetailsInfo.Status,
  };
}
